module.exports = __webpack_public_path__ + "static/img/freight.833a1f78.png";